var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestlistSin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49902 3.99668L9.79957 2.37101C9.98964 2.13391 10.2768 1.99585 10.5809 1.99585H14.4215C14.7256 1.99585 15.0127 2.13391 15.2028 2.37101L16.5024 3.99668V3.99668V4.9971C16.5024 5.54933 16.0542 5.99752 15.5019 5.99752H9.49944C8.94721 5.99752 8.49902 5.54933 8.49902 4.9971V3.99668V3.99668Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49874 3.9967H6.4979C5.39244 3.9967 4.49707 4.89208 4.49707 5.99754V19.003C4.49707 20.1084 5.39244 21.0038 6.4979 21.0038H18.5029C19.6084 21.0038 20.5037 20.1084 20.5037 19.003V5.99754C20.5037 4.89208 19.6084 3.9967 18.5029 3.9967H16.5021",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5017 12.5002L12.0006 15.0013L10.5 13.5007",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestlistSin);
export default __webpack_public_path__ + "static/media/Guestlist-sin.965e2b425d5fad3171a5caa5f02499db.svg";
export { ForwardRef as ReactComponent };